<template>
  <v-app-bar class="main-header" height="64" fixed color="white">
    <v-toolbar-title>
      <v-col class="text-right">
        <div @click="navigateToHome()" style="cursor: pointer;">
          <v-img width="194" src="@/assets/images/sk-logo-long.png"></v-img
        ></div>
      </v-col>
    </v-toolbar-title>
    <v-btn icon class="mx-1" @click.stop="toggleDrawer($event)">
      <v-icon size="28" color="#20368B">mdi-menu</v-icon>
    </v-btn>
    <v-spacer></v-spacer>

    <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-0" color="white" depressed v-bind="attrs" v-on="on">
          {{ user.full_name }} さん
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">
          {{ user.full_name }}
        </div>
        <div class="subtitle-2 primary--text font-weight-regular px-4">
          {{ user.email }}
        </div>
        <!-- <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in account"
            :key="i"
            :to="{ name: item.route }"
            link
          >
            <v-list-item-icon class="mr-4">
              <v-icon :color="item.color" v-text="item.icon"> </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                :color="config.light.textColor"
                v-text="item.text"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group> -->
        <div class="d-flex justify-center my-3">
          <v-btn
            width="80%"
            large
            outlined
            color="primary"
            class="text-capitalize"
            @click="logOut"
            >ログアウト
          </v-btn>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import config from '@/config'

export default {
  name: 'Header',
  data: () => ({
    config,
    account: [
      {
        text: 'Profile',
        icon: 'mdi-account-circle',
        color: 'iconColor',
        route: ''
      }
    ]
  }),
  computed: {
    ...mapState({
      drawer: state => state.drawer
      // user: state => state.auth.user
    }),
    ...mapGetters(['user']),
    DRAWER_STATE: {
      get() {
        return this.drawer
      }
    }
  },
  methods: {
    ...mapActions(['TOGGLE_DRAWER']),
    logOut: function() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    toggleDrawer(e) {
      this.TOGGLE_DRAWER()
    },
    navigateToHome() {
      if (this.$route.name === 'ScheduleTaskView') {
        return this.$root.$emit('logo-clicked', true)
      }

      this.$router.push({name: 'ScheduleTaskView'})
    }
  }
}
</script>

<style src="./Header.scss" scoped lang="scss"></style>
